import React from "react"

import GetAppIcon from "@material-ui/icons/GetApp"
import NavBarGlobal from "Components/UI/Molecules/NavBar"
import TemplateGlobal from "../../Common"
import SetState from "Components/Hooks/SetState"
import Export from "Components/UI/Organisms/Sales/Cobranzas/Export"

const CobranzasTemplate = () => {
  const { state, setOpen, setClose } = SetState()

  const BUTTONS = [
    {
      menuIcon: <GetAppIcon fontSize="small" />,
      menuTitle: "Descargar",
      buttonContent: <GetAppIcon />,
      onClick: setOpen,
    },
  ]
  return (
    <TemplateGlobal
      navbar={
        <NavBarGlobal title="Ventas" subTitle="Cobranzas" buttons={BUTTONS} />
      }
      table={
        <>
          {state.suspense && (
            <Export open={state.open} onClose={setClose} />
          )}
        </>
      }
    />
  )
}

export default CobranzasTemplate
